module.exports = __webpack_public_path__ + "static/media/choose_us.d363bd77.png";